module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step7-62db0925cbd3495572248560d02aae03.svg";